import * as css from "./style.css";

export function LoadingIndicator() {
  const s = 38;
  const r = 6;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${s} ${s}`}
      width={s}
      height={s}
      className={css.container}
    >
      <g stroke="inherit" fill="none">
        <circle cx={r + 1} cy={r + 1} r={r} strokeWidth="1.25" />
        <circle cx={s - r - 1} cy={r + 1} r={r} strokeWidth="1.25" />
        <circle cx={r + 1} cy={s - r - 1} r={r} strokeWidth="1.25" />
        <circle cx={s - r - 1} cy={s - r - 1} r={r} strokeWidth="1.25" />
      </g>
    </svg>
  );
}
